import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "besidaMob-warning.icon",
  "use": "besidaMob-warning.icon-usage",
  "viewBox": "0 0 106.031 106.031",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 106.031 106.031\" id=\"besidaMob-warning.icon\"><path d=\"M53.015 76.703c-5.815 0-10.528-4.712-10.528-10.528V10.528C42.487 4.714 47.201 0 53.015 0c5.813 0 10.528 4.714 10.528 10.528v55.647c.001 5.816-4.713 10.528-10.528 10.528z\" /><circle cx=\"52.34\" cy=\"97.007\" r=\"9.024\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol